import { useAsync } from 'react-async-hook';
import { getDeleteCompanyPermissions } from '../../../../api/custom/DeleteCompany';
import HrList from '../../../components/HrList';
import LinkButton from '../../../components/LinkButton';
import LoadingBar from '../../../components/LoadingBar';
import PageHeader from '../../../components/PageHeader';
import PageStaticSection from '../../../components/PageStaticSection';
import PageTitle from '../../../components/PageTitle';
import { useAppContext } from '../../../hooks/useAppContext';
import { isSuperUser } from '../../../services/User';
import AdminBreadcrumbs from '../components/AdminBreadcrumbs';
import DeleteCompanyForm from './DeleteCompanyForm';

export default function AdminDeleteCompanyPage() {
    const title = 'Delete Company';
    const { user } = useAppContext();
    const { loading, result: permissions } = useAsync(() => getDeleteCompanyPermissions(), []);
    const superUser = isSuperUser(user);

    return (
        <>
            <AdminBreadcrumbs page={title} />
            <PageTitle title={title} />
            <PageHeader title={`Delete ${user.company.name}`} />
            <PageStaticSection>
                {loading && <LoadingBar />}
                {!loading && permissions?.canDeleteCompany && isSuperUser(user) && (
                    <>
                        <p>You'll need to contact the support team to obtain the Deletion Password. </p>
                        <LinkButton
                            kind="PRIMARY"
                            href="mailto:support@small-improvements.com?subject=Delete%20Account"
                        >
                            Contact Support
                        </LinkButton>
                        <DeleteCompanyForm />
                    </>
                )}
                {!loading && !permissions?.canDeleteCompany && (
                    <>
                        {!superUser && (
                            <>
                                <p>
                                    Deleting your Small Improvements account is a permanent action. Only super admins
                                    (listed below) can delete a company.
                                </p>
                                <HrList filterFn={u => u.isAdmin && u.isHR} />
                            </>
                        )}
                        {superUser && <p>Please contact support to delete your account.</p>}
                        <LinkButton
                            kind="PRIMARY"
                            href="mailto:support@small-improvements.com?subject=Delete%20Account"
                        >
                            Contact Support
                        </LinkButton>
                    </>
                )}
            </PageStaticSection>
        </>
    );
}
